import { render, staticRenderFns } from "./spuEdit.vue?vue&type=template&id=72a60596&scoped=true"
import script from "./spuEdit.vue?vue&type=script&lang=js"
export * from "./spuEdit.vue?vue&type=script&lang=js"
import style0 from "./spuEdit.vue?vue&type=style&index=0&id=72a60596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a60596",
  null
  
)

export default component.exports